/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsButton, ExdsGrid} from "@exds/core";
import "./Header.scss";
import {TuxStepper} from '@tuxedo/react-component-library';
import {HELP_LINK} from "../../constants/constants";
import {addExitEvent} from "../AdobeAnalytics/AdobeAnalytics";
import {useContext} from "react";
import AppContext from "../../AppContext";

const Header = ({userValidated, currentStep, pageName, sid}) => {
  const {loadAA, isSoftTokenEnabledContext,isSmartLogonEnabledContext} = useContext(AppContext);
  const isSoftTokenEnabledBool = isSoftTokenEnabledContext.at(0) === "true";
  const isSmartLogonEnabledBool = isSmartLogonEnabledContext.at(0) === "true";

  const stepperData = () => {
    const stepStatus = (step) => {
      return currentStep === step ? 'active' : currentStep > step ? 'complete' : 'not started';
    };

    const steps = [
      {
        label: 'Validate Identity',
        status: currentStep > 1 ? 'complete' : 'active'
      },
      {
        disabled: currentStep < 2,
        label: 'Create Password',
        status: stepStatus(2)
      },
      {
        disabled: currentStep < 3,
        label: 'Security Questions',
        status: stepStatus(3)
      }
    ];

    if (isSmartLogonEnabledBool || isSoftTokenEnabledBool) {
      steps.push({
        disabled: currentStep < 4,
        label: 'Mobile App Setup',
        status: stepStatus(4)
      });
    }
    return steps;
  };

  return (
    <ExdsGrid
      className='top-bg-container'
      alignItems="center"
      columnSpan={12}
      container
      flexDirection="row"
      justifyContent="center"
    >
      {!userValidated ? <h1>Validate Identity</h1> : <TuxStepper data={stepperData()}/>}
      <ExdsButton
        color="brand"
        iconPosition="leading"
        size="regular"
        text="Help"
        variant="secondary"
        onClick={() => {
          if(loadAA) {
            addExitEvent(pageName, sid, HELP_LINK, 'Link', 'Help', 'Header');
          }
          window.open(HELP_LINK, "_blank");
        }}
        type="button"
      />
    </ExdsGrid>
  );
};

export default Header;
